// Colunas do grid.
import { formatCNPJ } from "../../../../utils/FormatUtils";
import { vacationLastDayLabel, vacationPeriodLabel, vacationStatus } from "../../../../utils/VacationUtils";

// Nome com o selo de férias, para o gestor ver na listagem quem está fora (ou vai sair)
// sem abrir cadastro por cadastro. Férias já encerradas não ganham selo: a agenda está
// aberta e o selo só faria barulho. Usa a família translúcida (`light badge-*`), a única
// com regra para o tema escuro.
// Colaborador ativo sem nenhuma filial ativa: só aparece na grade para quem enxerga todas as
// filiais, e some da agenda e dos selects. O selo diz por que ele está aqui e o que corrigir.
export const hasNoActiveBranch = (employee) => employee?.status === 'ACTIVE'
	&& !(employee?.branches || []).some((branch) => branch?.status === 'ACTIVE');

const nameRenderer = (params) => {
	const name = params.value || '-';
	const status = vacationStatus(params.data);

	// Só o ícone, sem selo: essa linha só aparece junto com o aviso acima da grade, que já
	// explica o problema. A dica no ícone repete o motivo para quem passa o mouse.
	if (hasNoActiveBranch(params.data)) {
		return (
			<span title="Sem filial ativa: vincule a uma filial ativa ou inative o cadastro">
				<i className="fas fa-triangle-exclamation me-2" style={{ color: '#d97706' }} aria-label="Sem filial ativa" />
				{name}
			</span>
		);
	}
	if (status === 'active') {
		return <span>{name} <span className="badge light badge-warning ms-1">De férias até {vacationLastDayLabel(params.data)}</span></span>;
	}
	if (status === 'scheduled') {
		return <span>{name} <span className="badge light badge-info ms-1" title={`Férias de ${vacationPeriodLabel(params.data)}`}>Férias programadas</span></span>;
	}
	return name;
};

export const Columns = [
	{
		headerName: 'name',
		field: 'fullName',
		filter: true,
		width: 280,
		cellRenderer: nameRenderer
	},
	{
		headerName: 'phone',
		field: 'phone',
		filter: true,
		width: 150
	},
	{
		headerName: 'cpf',
		field: 'document',
		filter: true,
		width: 160,
		type: 'cpf'
	},
	{
		headerName: 'cnpj',
		field: 'cnpj',
		filter: true,
		width: 180,
		valueFormatter: (params) => formatCNPJ(params.value)
	},
	{
		headerName: 'email',
		field: 'email',
		filter: true,
		width: 200
	},
	{
		headerName: 'birthDate',
		field: 'birthDate',
		type: 'date'
	},
	{
		headerName: 'gender',
		field: 'gender',
		width: 120
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans',
		with: 130
	}
]
